import React, { Component } from 'react'
import styled from 'styled-components'
import { provideState, injectState } from 'freactal'
import app from '../../../feathers'

import FullAreaContent from '../../components/FullAreaContent'
import Button from '../../../components/Button'
import { Grid, Cell, Switch } from 'react-mdl'
import UnitElementsBySections from './UnitElementsBySections'
import SummativePracticalAssessments from './SummativePracticalAssessments'

const StyledGrid = styled(Grid)`
  height: 100%;
  box-sizing: border-box;
  align-content: stretch;
`

const withState = provideState({
  initialState: () => ({
    addSummativePracticalAssessmentError: null,
    updateSummativePracticalAssessmentError: null,
    removeSummativePracticalAssessmentError: null,
    copySummativePracticalAssessmentError: null,
    updateMappingError: null,
  }),
  effects: {
    clearErrors: () => () => ({
      addSummativePracticalAssessmentError: null,
      updateSummativePracticalAssessmentError: null,
      removeSummativePracticalAssessmentError: null,
      copySummativePracticalAssessmentError: null,
      updateMappingError: null,
    }),
    addSummativePracticalAssessment: async (effects, { _id, name }) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          $push: {
            summativePracticalAssessments: {
              name,
            },
          },
        })
      } catch (addSummativePracticalAssessmentError) {
        return () => ({ addSummativePracticalAssessmentError })
      }
    },
    updateSummativePracticalAssessment: async (
      effects,
      { _id, summativePracticalAssessmentIndex, summativePracticalAssessment },
    ) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          [`summativePracticalAssessments.${summativePracticalAssessmentIndex}`]: summativePracticalAssessment,
        })
      } catch (updateSummativePracticalAssessmentError) {
        return () => ({ updateSummativePracticalAssessmentError })
      }
    },
    copySummativePracticalAssessment: async (
      effects,
      { _id, summativePracticalAssessmentIndex, summativePracticalAssessment }
    ) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          $push: {
              summativePracticalAssessments: summativePracticalAssessment,
            },
          })
        } catch (addSummativePracticalAssessmentError) {
          return () => ({ addSummativePracticalAssessmentError })
        }
    },
    removeSummativePracticalAssessment: async (
      effects,
      { _id, summativePracticalAssessmentId },
    ) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          $pull: {
            summativePracticalAssessments: {
              _id: summativePracticalAssessmentId,
            },
          },
        })
      } catch (removeSummativePracticalAssessmentError) {
        return () => ({ removeSummativePracticalAssessmentError })
      }
    },
    updateMapping: async (effects, { _id, mapping, index }) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          [`summativePracticalAssessments.${index}.mapping`]: mapping,
        })
      } catch (updateMappingError) {
        return () => ({ updateMappingError })
      }
    },
  },
})

class SummativePracticalIndex extends Component {
  state = {
    displayMapped: false,
  }
  getMapping(pracs) {
    return [].concat(
      ...pracs.map(({ mapping = [], tasks = [] }) =>
        mapping.concat(
          ...tasks.map(({ mapping = [], subtasks = [] }) =>
            mapping.concat(
              ...subtasks.map(({ mapping = [], subtasks = [] }) =>
                mapping.concat(...subtasks.map(({ mapping }) => mapping)),
              ),
            ),
          ),
        ),
      ),
    )
  }
  toggleDisplayMapped = ({ target }) =>
    this.setState({ displayMapped: target.checked })
  addSummativePracticalAssessment = async () => {
    const {
      state: { unit },
      effects: { addSummativePracticalAssessment },
    } = this.props
    await addSummativePracticalAssessment({
      _id: unit._id,
      name: 'New Summative Practical',
    })
  }
  updateSummativePractical = async (
    summativePracticalAssessment,
    summativePracticalAssessmentIndex,
  ) => {
    const {
      state: { unit },
      effects: { updateSummativePracticalAssessment },
    } = this.props
    await updateSummativePracticalAssessment({
      _id: unit._id,
      summativePracticalAssessment,
      summativePracticalAssessmentIndex,
    })
  }
  copySummativePractical = async (
    summativePracticalAssessment,
    summativePracticalAssessmentIndex,
  ) => {
    console.log('index.js = copySummativePractical', summativePracticalAssessment)
    const {
      state: { unit },
      effects: { copySummativePracticalAssessment },
    } = this.props
    await copySummativePracticalAssessment({
      _id: unit._id,
      summativePracticalAssessment,
      summativePracticalAssessmentIndex,
    })
  }
  removeSummativePractical = async summativePracticalAssessmentId => {
    const {
      state: { unit },
      effects: { removeSummativePracticalAssessment },
    } = this.props
    await removeSummativePracticalAssessment({
      _id: unit._id,
      summativePracticalAssessmentId,
    })
  }
  updateSummativePracticalMapping = async (mapping, index) => {
    const { state: { unit }, effects: { updateMapping } } = this.props
    await updateMapping({ _id: unit._id, mapping, index })
  }
  render() {
    const {
      state: { unit: { sections, summativePracticalAssessments } },
    } = this.props
    const { displayMapped } = this.state
    return (
      <FullAreaContent>
        <StyledGrid>
          <Cell col={4} style={{ position: 'relative' }}>
            <UnitElementsBySections
              sections={sections}
              displayMapped={displayMapped}
              mappedElements={this.getMapping(summativePracticalAssessments)}>
              Print out of the basic unit elements in the order they appear in the Learner Guide.
              <Switch
                checked={displayMapped}
                onChange={this.toggleDisplayMapped}>
                Display Mapped Elements
              </Switch>
            </UnitElementsBySections>
          </Cell>
          <Cell col={8}>
            <SummativePracticalAssessments
              summativePracticals={summativePracticalAssessments}
              updateSummativePractical={this.updateSummativePractical}
              removeSummativePractical={this.removeSummativePractical}
              copySummativePractical={this.copySummativePractical}
              updateSummativePracticalMapping={
                this.updateSummativePracticalMapping
              }
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                raised
                primary
                onClick={this.addSummativePracticalAssessment}>
                Add Summative Practical Assessment
              </Button>
            </div>
          </Cell>
        </StyledGrid>
      </FullAreaContent>
    )
  }
}

export default withState(injectState(SummativePracticalIndex))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/index.js